import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { BookOpen, ExternalLink } from "lucide-react";
import colors from "@styling/colors";
import { spacing } from "@styling/sizing";
import { fontSizes } from "@styling/fonts";
import { useHelpCenterHref } from "./useHelpCenterHref";

const Link = styled.a`
  display: flex;
  align-items: center;
  gap: ${spacing.x1}px;
  min-height: 44px;
  margin-top: ${spacing.x2}px;
  padding: ${spacing.x2}px ${spacing.x3}px;
  border-top: 1px solid ${colors.border};
  color: ${colors.text};
  font-size: ${fontSizes.regular}px;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.primary};
    color: ${colors.primaryContrastText};
  }

  span {
    flex: 1;
  }

  @media (max-width: 768px) {
    padding: ${spacing.x1}px ${spacing.x2}px;
    min-height: 40px;
  }
`;

export const HelpCenterSidebarLink = () => {
  const { t } = useTranslation();
  const href = useHelpCenterHref();

  return (
    <Link href={href} target="_blank" rel="noopener">
      <BookOpen size={18} />
      <span>{t("help.center")}</span>
      <ExternalLink size={14} />
    </Link>
  );
};
